const getTokenLogoURL = (address: string) => `https://ejoe.metabest.tech/images/tokens/${address}.png`

export default getTokenLogoURL
